<template>
  <span class="xs-money-container" :class="{ 'is-edit': isEdit }">
    <template v-if="isEdit">
      <el-input-number
        class="xs-money-input"
        :value="value"
        v-bind="$attrs"
        :precision="+precision"
        :controls="false"
        size="mini"
        :style="dynamicStyleRoot"
        v-on="listeners"
      />
      <el-button
        v-if="valueNotNull"
        type="text"
        size="mini"
        class="xs-money-round-off"
        @click="handleRoundOff"
      >抹零</el-button>
    </template>
    <span
      v-else
      class="xs-money"
      :style="dynamicStyleRoot"
      v-bind="$attrs"
      @dblclick="toggleSeparatorDisplay"
      v-on="listeners"
    >
      <span
        v-if="showSymbol && valueNotNull"
        class="xs-money-symbol"
        :class="{ 'xs-money-symbol-noselect': !symbolCanSelect }"
      >￥</span>
      <span
        :class="{ 'xs-empty-string': !valueNotNull,'xs-bold': bold }"
        class="xs-money-value"
        v-html="formated || emptyString"
      />
    </span>
  </span>
</template>
<script>

// https://currency.js.org/
// npm install --save currency.js
import currency from 'currency.js'

export default {
  name: 'Money',
  inheritAttrs: false,
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: null
    },
    color: {
      type: String,
      default: 'inherit'
    },
    moneySymbol: {
      type: String,
      default: '￥'
    },
    precision: {
      type: [Number, String],
      default: 2
    },
    emptyString: {
      type: String,
      default: ''
    },
    showSymbol: {
      type: Boolean,
      default: false
    },
    separator: {
      type: String,
      default: ','
    },
    symbolCanSelect: {
      type: Boolean,
      default: false
    },
    disableToggleSeparator: {
      type: Boolean,
      default: false
    },
    emptyStringColor: {
      type: String,
      default: 'inherit'
    },
    bold: {
      type: Boolean,
      default: false
    },
    valueSize: {
      type: Number,
      default: null
    },
    isEdit:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      separatorDisplay: 'initial'
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners
      }
    },
    formated() {
      if (!this.value && this.value !== 0) {
        return null
      }
      return currency(this.value, {
        symbol: '',
        separator: `<span class="xs-money-separator">${this.separator}</span>`,
        precision: this.precision
      }).format()
    },
    valueNotNull() {
      return this.value !== null && this.value !== undefined && this.value !== ''
    },
    dynamicStyleRoot() {
      return {
        '--separator-display': this.separatorDisplay,
        '--color': this.valueNotNull ? this.color : this.emptyStringColor,
        '--font-size': this.valueSize ? `${this.valueSize}px` : 'inherit'
      }
    }
  },
  methods: {
    toggleSeparatorDisplay() {
      if (this.disableToggleSeparator) {
        return
      }
      this.separatorDisplay = this.separatorDisplay === 'none' ? 'initial' : 'none'
    },
    handleRoundOff() {
      if (!this.valueNotNull) {return}
      const val = Math.floor(Number(this.value))
      const lastTwo = val % 100
      let newValue
      if (lastTwo < 50) {
        newValue = val - lastTwo
      } else {
        newValue = val - lastTwo + 50
      }
      this.$emit('input', newValue)
      this.$emit('change', newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.xs-money {
  color: var(--color);
  font-size: var(--font-size);
}

.xs-money-symbol {
  font-size: 0.7em;
}

.xs-money-symbol-noselect {
  user-select: none;
}
.xs-money-value{
  font-size: var(--font-size);
}


.xs-bold {
  font-weight: bold;
}

.xs-money-container {
  display: inline-block;
  vertical-align: middle;
  &.is-edit {
    display: inline-flex;
    align-items: center;
  }
}

.xs-money-input {
  width: 150px;
  &.el-input-number.is-without-controls ::v-deep .el-input__inner {
    padding-left: 2px;
    padding-right: 2px;
    text-align: inherit;
    color: var(--color);
    font-size: var(--font-size);
    height: auto;
    line-height: inherit;
  }
}

.xs-money-round-off {
  margin-left: 5px;
  padding: 8px;
}

::v-deep .xs-money-separator {
  display: var(--separator-display);
}
</style>
